import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { AuthContext, type AuthState } from './AuthContext';
import { meMock, perfilMockDesat } from './mockMe';

const CLAU_SESSIO = 'cai.mock.sessio';

function sessioDesada(): boolean {
  try {
    return sessionStorage.getItem(CLAU_SESSIO) === '1';
  } catch {
    return false;
  }
}

export function MockAuthProvider({
  children,
  inicial,
}: {
  children: ReactNode;
  inicial?: boolean;
}) {
  const [autenticat, setAutenticat] = useState<boolean>(inicial ?? sessioDesada());

  const login = useCallback(async () => {
    try {
      sessionStorage.setItem(CLAU_SESSIO, '1');
    } catch {
      /* empty */
    }
    setAutenticat(true);
  }, []);

  const logout = useCallback(async () => {
    try {
      sessionStorage.removeItem(CLAU_SESSIO);
    } catch {
      /* empty */
    }
    setAutenticat(false);
  }, []);

  const obteToken = useCallback(
    async () => (autenticat ? `mock.${perfilMockDesat()}` : null),
    [autenticat],
  );

  const valor = useMemo<AuthState>(() => {
    const me = meMock(perfilMockDesat());
    return {
      mode: 'mock',
      autenticat,
      carregant: false,
      compte: autenticat ? { nom: `${me.nom} ${me.cognoms ?? ''}`.trim(), upn: me.upn } : null,
      login,
      logout,
      obteToken,
    };
  }, [autenticat, login, logout, obteToken]);

  return <AuthContext.Provider value={valor}>{children}</AuthContext.Provider>;
}
